import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, LinearProgress, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { useDrawerContext } from '../../../context';
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        flexDirection: 'column',
        alignSelf: 'flex-end',
        [theme.breakpoints.only('xs')]: {
            '& .MuiButtonBase-root, & .MuiButtonBase-root + .MuiButtonBase-root': {
                margin: theme.spacing(0, 0, 2),
            },
        },
    },
    container: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: theme.spacing(2, 4),
        backgroundColor: theme.palette.brand.sky25,
        flex: 1,
        [theme.breakpoints.up('sm')]: {
            '& > :not(:first-child)': {
                marginLeft: theme.spacing(2),
            },
        },
        [theme.breakpoints.only('xs')]: {
            flexDirection: 'column',
            paddingBottom: 0,
        },
    },
}));
/**
 * DrawerFooter component for the Drawer.
 *
 * This component renders the footer for the Drawer.
 * The footer can contain any content, such as buttons or alerts.
 *
 * @param {DrawerFooterProps} props
 */
export const DrawerFooter = ({ children, className, alert, testId }) => {
    const classes = useStyles();
    const { isLoading } = useDrawerContext();
    return (_jsxs("div", { className: clsx(classes.root, className), "data-testid": testId, children: [alert, isLoading ? _jsx(LinearProgress, {}) : _jsx(Divider, {}), _jsx("div", { className: classes.container, children: children })] }));
};
